import { loginConstants } from "./types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case loginConstants.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        info: action.login
      };
    case loginConstants.LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        info: action.login
      };

    case loginConstants.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        controlExpirePassword: true,
      };
    case loginConstants.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false,
        controlExpirePassword: false,
      };
    case loginConstants.RESET_PASSWORD_FAILURE:
      return {
        loggingIn: false,
        loggedIn: false,
        controlExpirePassword: true,
      };


    case loginConstants.LOGIN_OTP_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false
      };
    case loginConstants.LOGIN_OTP_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        controlSmsVerify: false,
        controlEpostaVerify: false,
        info: action.login
      };
    case loginConstants.LOGIN_OTP_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        info: action.login
      };
    case loginConstants.LOGIN_OTP_SMSVERIFY:
      return {
        ...state,
        ...action.payload,
        controlSmsVerify: true,
        controlEpostaVerify: false,
        loggingIn: false
      };
    case loginConstants.LOGIN_OTP_EPOSTAVERIFY:
      return {
        ...state,
        ...action.payload,
        controlSmsVerify: false,
        controlEpostaVerify: true,
        loggingIn: false
      };
    case loginConstants.LOGIN_OTP_EXPIREPASSWORD:
      return {
        ...state,
        ...action.payload,
        controlSmsVerify: false,
        controlEpostaVerify: false,
        controlExpirePassword: true,
        loggingIn: false
      };


    case loginConstants.LOGIN_VERIFY_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false
      };
    case loginConstants.LOGIN_VERIFY_REQUEST:
      return {
        ...state,
        loggingIn: true,
        loggedIn: false,
        info: action.login
      };
    case loginConstants.LOGIN_VERIFY_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        info: action.login
      };


    case loginConstants.LOGIN_FAILURE:
      return {
        ...state,
        loggingIn: false,
        loggedIn: false
      };
    case loginConstants.LOGIN_CANDIDATE_REQUEST:
      return {
        ...state,
        ...action.payload,
        controlCandidate: false,
        controlNewCandidate: false,
        loggingIn: true
      };
    case loginConstants.LOGIN_CANDIDATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        controlCandidate: true,
        controlNewCandidate: false,
        loggingIn: false
      };
    case loginConstants.LOGIN_CANDIDATE_SUCCESS_NEW:
      return {
        ...state,
        ...action.payload,
        controlNewCandidate: true,
        controlCandidate: false,
        loggingIn: false
      };
    case loginConstants.LOGIN_CANDIDATE_FAILURE:
      return {
        ...state,
        controlCandidate: false,
        controlNewCandidate: false,
        loggingIn: false
      };
    case loginConstants.CLEAR_CANDIDATE_REDIRECT:
      return {
        ...state,
        controlCandidate: false,
        controlNewCandidate: false,
        loggingIn: false
      };
    case loginConstants.HIDE_SMS_MODAL:
      return {
        ...state,
        controlSmsVerify: false,
        controlEpostaVerify: false,
        controlExpirePassword: false,
        loggingIn: false
      };
    case loginConstants.LOGOUT:
      return {};

    case loginConstants.ADD_LEAD_REQUEST:
      return {
        ...state,
        info: action.login,
        loggingIn: true,
        leadSubmitting: true,
        leadSuccess: false
      };
    case loginConstants.ADD_LEAD_SUCCESS:
      return {
        ...state,
        info: action.login,
        loggingIn: false,
        leadSubmitting: false,
        leadSuccess: true
      };
    case loginConstants.ADD_LEAD_FAILURE:
      return {
        ...state,
        loggingIn: false,
        leadSubmitting: false,
        leadSuccess: false
      };
    case loginConstants.RESET_LEAD_SUCCESS:
      return {
        ...state,
        leadSuccess: false
      };
    default:
      return state;
  }
};
